import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="turbo-rescue"
export default class extends Controller {
  connect() {
    this.handleServerError = this.handleServerError.bind(this);
    this.handleBeforeFetchResponse = this.handleBeforeFetchResponse.bind(this);
    
    document.addEventListener("turbo:frame-missing", this.handleServerError);
    document.addEventListener("turbo:before-fetch-response", this.handleBeforeFetchResponse);
  }

  disconnect() {
    document.removeEventListener("turbo:frame-missing", this.handleServerError);
    document.removeEventListener("turbo:before-fetch-response", this.handleBeforeFetchResponse);
  }

  handleServerError(event) {
    event.preventDefault();
    
    const systemAlertsElement = document.querySelector('[data-controller~="system-alerts"]');
    if (systemAlertsElement) {
      const systemAlertsController = this.application.getControllerForElementAndIdentifier(systemAlertsElement, "system-alerts");
      if (systemAlertsController) {
        systemAlertsController.createAlert("danger", "A system error occurred. Please try again or contact support if the issue persists.");
      }
    }
  }

  handleBeforeFetchResponse(event) {
    const response = event.detail.fetchResponse.response;
    
    if (response.status === 500) {
      this.handleServerError(event);
    }
  }
}
